const CHAT_SUMMARY = 'CHAT_SUMMARY';
const CUSTOM_FIELD_SUGGESTIONS = 'CUSTOM_FIELD_SUGGESTIONS';

export {
  CHAT_SUMMARY,
  CUSTOM_FIELD_SUGGESTIONS
}